import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTimeKeeperEmployer, updateProps } from '../../../contextRedux/TimeKeeperEmployer/TimeKeeperEmployerModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { TimeKeeperEmployerColumn } from './TimeKeeperEmployerColumn';

const TimeKeeperEmployerTable: FC<any> = () => {
  const dispatch = useDispatch();

  const reduxTimeKeeperEmployer = useSelector((state: RootState) => state.models?.timeKeeperEmployer);
  const timeKeeperEmployers = useSelector((state: RootState) => state.store?.timeKeeperEmployer.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxTimeKeeperEmployer.props.skip / reduxTimeKeeperEmployer.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setTimeKeeperEmployer(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxTimeKeeperEmployer.props.take,
    total: reduxTimeKeeperEmployer.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxTimeKeeperEmployer.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={timeKeeperEmployers}
        pagination={paginationConfig}
        rowKey='id'
        columns={TimeKeeperEmployerColumn(handleEdit)}
      />
    </>
  );
};

export default TimeKeeperEmployerTable;
